import {useCallback, useContext} from 'react';

import {ValidationContext} from 'src/contexts/validation-context';
import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {createPreset} from 'src/openapi/admin/apis/EntitlementsPresetApi';
import {useAppDispatch} from 'src/store/hooks';

import {
    DEFAULT_PRESET,

    PRESET_NAME_CONTROL,
    PRESET_NAME_REQUIRED_ERROR,
    PRESET_NAME_REQUIRED_MESSAGE,
} from './constants';

import type {CreatePresetRequest} from 'src/openapi/admin/models/CreatePresetRequest';

export const useCreatePreset = () => {
    const apiDispatch = useAppDispatch();
    const {addError, removeError} = useContext(ValidationContext);

    const getDispatchAction = useCallback(() => {
        const payload: {success: true, error: false, data: CreatePresetRequest} = {
            success: true,
            error: false,
            data: DEFAULT_PRESET,
        };
        return Promise.resolve({type: '', payload});
    }, []);

    const saveDispatchAction = useCallback((
        createPresetRequest: CreatePresetRequest,
        signal: AbortSignal,
    ) => apiDispatch(
        createPreset({createPresetRequest}, {signal}),
    ), [apiDispatch]);

    const editValidation = useCallback((data: CreatePresetRequest) => {
        if (data.name) {
            removeError(PRESET_NAME_CONTROL);
        }
    }, [removeError]);

    const saveValidation = useCallback((data: CreatePresetRequest) => {
        let valid = true;

        if (!data.name) {
            addError({
                controlId: PRESET_NAME_CONTROL,
                code: PRESET_NAME_REQUIRED_ERROR,
                message: PRESET_NAME_REQUIRED_MESSAGE,
            });
            valid = false;
        }

        return valid;
    }, [addError]);

    return useCommonDataHook({
        initValue: DEFAULT_PRESET,
        getDispatchAction,
        saveDispatchAction,
        editValidation,
        saveValidation,
    });
};
